<!-- Tested Units Sync Confirmation Modal — shared gtw-confirmation-modal (Pattern 8) -->

<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="showModal"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
